import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AvanoButtonBarButtonDetails } from './avano-button-bar.common';
import { AvanoButtonBarModule } from './avano-button-bar.module';

@Injectable({
  providedIn: AvanoButtonBarModule
})
export class AvanoButtonBarService {
  private readonly _buttonBarDetails$: BehaviorSubject<AvanoButtonBarButtonDetails[]> = new BehaviorSubject([]);
  readonly buttonBarDetails$: Observable<AvanoButtonBarButtonDetails[]> = this._buttonBarDetails$.asObservable();

  addOrUpdate(buttons: AvanoButtonBarButtonDetails[]) {
    const currentButtons = [...this._buttonBarDetails$.getValue()];
    const searchFunc = (button: AvanoButtonBarButtonDetails) => {
      return currentButtons.find((buttonDetails) => buttonDetails.label === button.label && buttonDetails.icon === button.icon);
    }
    buttons.forEach(buttonToAddOrUpdate => {
      const existingButton = searchFunc(buttonToAddOrUpdate);
      if (existingButton) {
        currentButtons.splice(currentButtons.indexOf(existingButton), 1, buttonToAddOrUpdate)
      } else {
        currentButtons.push(buttonToAddOrUpdate);
      }
    })
    this._buttonBarDetails$.next(currentButtons);
  }
}
